module.exports = __webpack_public_path__ + "img/blog-4-2.1472e873.webp";